import { useState, useRef, useEffect } from 'react';

import family1946 from '../images/familyphotos/EarlLaurettaBartholomeButchJudyDianeVirgAlanJohnnyHubIoneMorgan_1946.jpg';
import backStepsOfGrandpaEmmingsHouse from '../images/familyphotos/HelenVirgAndJohnnyOnTheBackStepsOfGrandpaEmmingsHouse_1941.jpg';
import hockeyPlayerPalsWithTheirChildren from '../images/familyphotos/HockeyPlayerPalsWithTheirChildren.jpg';
import johnnieAndRuthie from '../images/familyphotos/JohnnieAndRuthie.jpg';
import virgAndJohnnyEaster from '../images/familyphotos/VirgAndJohnnyAtGrandparentsJohnsonsEaster_1943.jpg';
import VirgAndJohnnyChristmas from '../images/familyphotos/VirgAndJohnnyChristmas_1939.jpg';
import VirgWithTheScotvoldTwins from '../images/familyphotos/VirgWithTheScotvoldTwins_Joyce_and_Joan_1934.jpg';
import VirgWithAlanAndNephews from '../images/familyphotos/VirgWithAlanAndNephewsJohnnyandEddieBarnesDeerLakeWisconsin.jpg';

import {
  CarouselWrap,
  CarouselImage
} from '../css/_styledComponents';

const imageData = {
  "resources": [
    {
      title: `Earl and Lauretta Bartholome (L) with Butch, Judy, Diane; Virg Johnson (C) with Alan and Johnny; Hub and Ione Nelson (R) with Morgan. Minneapolis 1946`,
      imageUrl: family1946
    },
    {
      title: `Helen, Virg, and Johnny on the back steps of Grandpa Emmings house, 1941`,
      imageUrl: backStepsOfGrandpaEmmingsHouse
    },
    {
      title: `Hockey players with their children, Cully Dahlstrom, Ted Breckheimer, Bill McGlone, Evy Scotvold, Earl Bartholome, and Virg. Minneapolis May 24, 1942`,
      imageUrl: hockeyPlayerPalsWithTheirChildren
    },
    {
      title: `Virg to Agnes, "Johnnie and Ruthie sat up on a table and had their pictures taken. Johnnie had on his sailor suit, looked very nice I'd say."  Chicago, Spring 1944`,
      imageUrl: johnnieAndRuthie
    },
    {
      title: `Virg and Johnny at Grandparents Johnson's, Easter 1943.`,
      imageUrl: virgAndJohnnyEaster
    },
    {
      title: `Virg and Johnny, Christmas 1939`,
      imageUrl: VirgAndJohnnyChristmas
    },
    {
      title: `Virg with the twins, Joyce and Joan Scotvold 1934`,
      imageUrl: VirgWithTheScotvoldTwins
    },
    {
      title: `Virg (UR) With Alan and nephews Johnny (UL) and Eddie Barnes, Deer Lake, Wisconsin August 1956`,
      imageUrl: VirgWithAlanAndNephews
    }
  ]
}

const Carousel = () => {
  const [move, setMove] = useState(null);
  const playing = useRef(true);
  const carousel = useRef(null);

  const movePrev = () => {
    setMove('prev')
  };

  const moveNext = () => {
    setMove('next')
  };

  const autoPlay = () => {
    if (playing.current)  {
      setMove('next');
    }
  }

  useEffect(() => {
    if (carousel !== null && carousel.current !== null) {
      setTimeout(() => {
        const images = document.querySelectorAll(`.image`);
        carousel.current.style.left = `-${images[1].offsetLeft}px`;
      }, 50)
      setInterval(function(){ 
        autoPlay();
      }, 3000);
    }
  }, [])

  useEffect(() => {
    if (carousel !== null && carousel.current !== null) {
      const images = document.querySelectorAll(`.image`);
      if (move === 'next') {
        carousel.current.classList.add('transition');
        carousel.current.style.left = `-${images[2].offsetLeft}px`;
        carousel.current.ontransitionend = () => {
          carousel.current.classList.remove('transition');
          carousel.current.appendChild(images[0]);
          carousel.current.style.left = `-${images[2].offsetLeft}px`;
        };
      }
      if (move === 'prev') {
        carousel.current.classList.add('transition');
        carousel.current.style.left = 0;
        carousel.current.ontransitionend = () => {
          carousel.current.classList.remove('transition');
          carousel.current.insertBefore(images[images.length - 1], carousel.current.firstChild);
          carousel.current.style.left = `-${images[0].offsetLeft}px`;
        };
      }
      setMove(null);
    }
  }, [move]);

  return (
    <CarouselWrap
      className="carousel"
      onMouseEnter={() => playing.current = false}
      onMouseLeave={() => playing.current = true}
    >
      <div style={{ position: 'relative', overflow: 'hidden' }}>
        <div className="buttons">
          <button
            className="prev"
            onClick={movePrev}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
            <span className="sr-only">Prev</span>
          </button>
          <button
            className="next"
            onClick={moveNext}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
            <span className="sr-only">Next</span>
          </button>
        </div>
        <div className="innerWrap" ref={carousel} >
          {imageData.resources.map((resource, index) => (
            <CarouselImage className="image" data-index={index} key={index}>
              <img src={resource.imageUrl} />
              <div className="caption">
                <div className="title">
                  {resource.title}
                </div>
              </div>
            </CarouselImage>
          ))}
        </div>
      </div>
    </CarouselWrap>
  );
};

export default Carousel;